import React from 'react';
import ReactDOM from 'react-dom/client';
import 'styles/index.sass';
import 'styles/leaflet.css';
import App from 'components/App'
import { Provider } from 'react-redux';
import store from 'js/redux/pqdStore';
import Header from 'components/main/Header';
import Footer from 'components/main/Footer'

import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
    <Provider store={store}>
      <div style={{height: "100%"}}>
        <Header />
        <App />
        <Footer /> 
      </div>
    </Provider>
  //</React.StrictMode>
);
